// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + ' : déplacement effectué.',
  accButtonProgressComplete: (p: { label: string }) => 'Action ' + p['label'] + ' terminée',
  accButtonProgressStatus: (p: { label: string }) => 'Action ' + p['label'] + ' en cours',
  accColorPalette: () => 'Palette de couleurs',
  accColorSwatch: () => 'Echantillon de couleur',
  accCommandKey: () => 'Commande',
  accContextMenuLabel: () => 'actions',
  accControlKey: () => 'Fermeture',
  accPositionAfter: () => 'après',
  accPositionBefore: () => 'avant',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Maintenez les touches ' +
    p['keyPressed'] +
    ' et Maj enfoncées, puis utilisez les touches fléchées pour effectuer la réorganisation.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Entrez une date complète, par exemple : ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Entrez un mois et une année, par exemple : ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Libellé',
  chart_labelGroup: () => 'Groupe',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valeur',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  checkbox_helpForCheckbox: () => 'Aide relative à la case à cocher',
  checkbox_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  checkbox_selected: () => 'Case cochée',
  checkbox_unselected: () => 'Case non cochée',
  close: () => 'Fermeture',
  collection_apply: () => 'Appliquer',
  collection_cancel: () => 'Annuler',
  collection_loaded: () => 'Chargé',
  collection_loading: () => 'Chargement en cours',
  collection_noData: () => 'Aucune donnée à afficher.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Redimensionner la colonne',
  collection_resizeColumnMenu: () => 'Redimensionner la colonne...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Saisissez un nombre compris entre ' + p['MIN'] + ' et ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Sélectionner toutes les lignes',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Sélectionner la ligne ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Croissant',
  collection_sortColumnMenu: () => 'Trier la colonne',
  collection_sortDescendingSubMenu: () => 'Décroissant',
  collection_sortDisabled: () => 'Non triable',
  collection_sortEnabled: () => 'Triable',
  collection_width: () => 'Largeur',
  colorPicker_label: () => 'Sélecteur de couleur',
  confirmation: () => 'Confirmation',
  datePicker_currentDate: () => 'Date en cours',
  datePicker_goToToday: () => "Accéder à Aujourd'hui",
  datePicker_label: () => 'Sélecteur de date',
  datePicker_month: () => 'Mois',
  datePicker_months: () => 'Mois',
  datePicker_next: () => 'Suivant',
  datePicker_nextDecade: () => 'Décennie suivante',
  datePicker_nextMonth: () => 'Mois suivant',
  datePicker_prev: () => 'Précédent',
  datePicker_prevDecade: () => 'Décennie précédente',
  datePicker_prevMonth: () => 'Mois précédent',
  datePicker_restricted: () => 'Restreint',
  datePicker_selected: () => 'Sélectionné',
  datePicker_today: () => "Aujourd'hui",
  datePicker_weekNum: (p: { NUM: string }) => 'Semaine ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Numéro de la semaine',
  datePicker_year: () => 'Année',
  datePicker_years: () => 'Années',
  diagram_promotedLink: () => '1 lien',
  diagram_promotedLinkAriaDesc: () => 'Indirect',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' liens',
  error: () => 'Erreur',
  expandableList_expandCollapseInstructionText: () =>
    'Utilisez les touches fléchées pour effectuer un développement ou une réduction',
  expandableList_groupCollapse: () => 'Réduit',
  expandableList_groupExpand: () => 'Développé',
  filePicker_addFiles: () => 'Ajouter des fichiers',
  filePicker_dropzonePrimaryText: () => 'Glisser-déplacer',
  filePicker_dropzoneSecondaryText: () => 'Sélectionner un fichier ou en déplacer un ici',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Sélectionner ou déplacer des fichiers ici',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Vous ne pouvez pas télécharger des fichiers de type ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Téléchargez un fichier à la fois',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Vous ne pouvez pas télécharger des fichiers de type ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'inconnu',
  formControl_clear: () => 'Effacer',
  formControl_day: () => 'Jour',
  formControl_empty_segment: () => 'Vide',
  formControl_helpAvailable: () => 'Aide disponible',
  formControl_hide: () => 'Masquer',
  formControl_hour: () => 'Heure',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Vous avez atteint la limite de ' +
    ((
      {
        one: new Intl.NumberFormat('fr').format(p['CHARACTER_LIMIT']) + ' caractère',
        many: new Intl.NumberFormat('fr').format(p['CHARACTER_LIMIT']) + ' de caractères'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('fr').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('fr').format(p['CHARACTER_LIMIT']) + ' caractères') +
    '.',
  formControl_loading: () => 'Chargement en cours',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    "Vous pouvez saisir jusqu'à " + p['MAX_LENGTH'] + ' caractères.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longueur maximale de ' + p['MAX_LENGTH'] + ' dépassée.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractères restants.',
  formControl_millisecond: () => 'Milliseconde',
  formControl_minute: () => 'Minute',
  formControl_month: () => 'Mois',
  formControl_readOnly: () => 'Lecture seule',
  formControl_requiredMessageDetail: () => 'Entrez une valeur.',
  formControl_second: () => 'Seconde',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Sélectionnez ' + p['n'] + ' valeurs.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Vous avez atteint la limite de sélection (' + p['max'] + ').',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Sélectionnez entre ' + p['min'] + ' et ' + p['max'] + ' valeurs.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Sélectionnez au moins ' + p['min'] + ' valeurs.',
  formControl_show: () => 'Afficher',
  formControl_year: () => 'Année',
  gantt_labelDate: () => 'Date',
  gantt_labelEnd: () => 'Fin',
  gantt_labelLabel: () => 'Libellé',
  gantt_labelRow: () => 'Ligne',
  gantt_labelStart: () => 'Début',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + ". Aucune section correspondante n'a été trouvée.",
  indexer_keyboardInstructionText: () => 'Appuyez sur Entrée pour sélectionner une valeur.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' et ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    "Touchez deux fois et maintenez le toucher pour passer en mode d'opération, puis faites glisser vers le haut ou le bas pour ajuster la valeur.",
  info: () => 'Information',
  inputColor_selectColor: () => 'Sélectionner une couleur',
  inputDateMask_date_cleared: () => 'Date effacée',
  inputDateMask_dayPlaceholder: () => 'jj',
  inputDateMask_empty_segment: () => 'Vide',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez une date antérieure ou égale au ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez une date postérieure ou égale au ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Entrez une date disponible.',
  inputDatePicker_instruction: () =>
    'Appuyez sur la touche de tabulation pour accéder au calendrier.',
  inputDatePicker_selectDate: () => 'Sélectionner une date',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez une année et un mois antérieurs ou égaux à ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez une année et un mois ultérieurs ou égaux à ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Entrez un nombre.',
  inputNumber_decrease: () => 'Diminuer',
  inputNumber_increase: () => 'Augmenter',
  inputPassword_hidden: () => 'Mot de passe masqué',
  inputPassword_hide: () => 'Masquer le mot de passe',
  inputPassword_show: () => 'Afficher le mot de passe',
  inputSensitiveText_hidden: () => 'Texte confidentiel masqué',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez une heure antérieure ou égale à ' + p['max'] + '.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez une heure postérieure ou égale à ' + p['min'] + '.',
  inputTimeMask_time_cleared: () => 'Heure effacée',
  labelNone: () => 'Aucun',
  list_msgFetchCompleted: () => 'Chargé',
  list_msgFetchingData: () => 'Chargement en cours',
  list_suggestion: () => 'Suggestion',
  menu_stateLoading: () => 'Chargement en cours',
  messageToast_allMessagesClosed: () => 'Tous les messages "toast" sont fermés.',
  message_close: () => 'Fermeture',
  message_confirmation: () => 'Succès',
  message_error: () => 'Erreur',
  message_info: () => 'Information',
  message_navigationFromMessagesRegion: () =>
    'Accès à la région des messages. Appuyez sur F6 pour y accéder.',
  message_navigationToMessagesRegion: () =>
    'La région des messages comporte de nouveaux messages. Appuyez sur F6 pour y accéder.',
  message_navigationToTouch: () => 'La région des messages comporte de nouveaux messages.',
  message_warning: () => 'Avertissement',
  noData_message: () => 'Aucun élément à afficher',
  overflowItemLabel: () => "Plus d'onglets",
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Touchez deux fois pour fermer la fenêtre instantanée ouverte.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Accès à la fenêtre instantanée. Appuyez sur F6 pour naviguer entre la fenêtre instantanée et le contrôle associé.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Fenêtre instantanée ouverte. Appuyez sur F6 pour naviguer entre la fenêtre instantanée et le contrôle associé.',
  progressIndeterminate: () => 'En cours',
  radioButton_checked: () => 'Bouton radio sélectionné',
  radioButton_selected: () => 'Bouton radio sélectionné',
  radioButton_unchecked: () => 'Bouton radio non sélectionné',
  radioButton_unselected: () => 'Bouton radio non sélectionné',
  radio_helpForRadio: () => 'Aide pour le bouton radio',
  radio_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  selectMultiple_apply: () => 'Appliquer',
  selectMultiple_back: () => 'Retour',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Utilisez les touches fléchées vers la gauche et vers la droite afin de mettre en évidence les valeurs sélectionnées.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Appuyez sur la touche Retour arrière ou Suppr pour enlever la valeur sélectionnée.',
  selectMultiple_selectedValues: () => 'Valeurs sélectionnées',
  selectMultiple_showSelectedValues: () => 'Affichez uniquement les valeurs sélectionnées.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valeurs sélectionnées.',
  select_addToList: () => 'Ajouter à la liste',
  select_addToListAvailable: () => 'Ajouter à la liste (disponible)',
  select_closeDropdown: () => 'Appuyez sur Echap pour fermer.',
  select_moreSearchOptions: () => 'Options de recherche supplémentaires',
  select_moreSearchOptionsAvailable: () => 'Options de recherche supplémentaires (disponible)',
  select_noMatchesFound: () => 'Aucune correspondance trouvée.',
  select_oneMatchFound: () => 'Une correspondance a été trouvée',
  select_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances trouvées',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Au moins ' + p['TOTAL_SIZE'] + ' correspondances trouvées',
  selectorAll_deselectAll: () => 'Tout désélectionner',
  selectorAll_selectAll: () => 'Tout sélectionner',
  selector_selected: () => 'Case cochée',
  selector_unselected: () => 'Case non cochée',
  sheet_close: () => 'Fermeture',
  switch_off: () => 'Désactivé',
  switch_on: () => 'Activé',
  tabBarNavigationList_removeCueText: () => 'Peut être enlevé',
  tabBar_tabContainsErrors: () => 'Contient des erreurs',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' enlevé',
  tabbar_labelContextMenu: () => 'a un menu contextuel',
  tabbar_labelMoveLeft: () => 'Déplacer vers la gauche',
  tabbar_labelMoveRight: () => 'Déplacer vers la droite',
  tabbar_labelRemove: () => 'Enlever',
  timeComponent_tooltipZoomIn: () => 'Zoom avant',
  timeComponent_tooltipZoomOut: () => 'Zoom arrière',
  timeConverter_parseError: () => 'Saisissez une heure complète.',
  train_current: () => 'En cours',
  train_message_type: () => 'Type de message',
  train_not_visited: () => 'Non consulté',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etape ' + p['currentStep'] + ' sur ' + p['numberOfSteps'],
  train_visited: () => 'Consulté',
  userAssistance_learnMore: () => 'En savoir plus',
  userAssistance_required: () => 'Obligatoire',
  vis_clearSelection: () => 'Effacer la sélection',
  vis_drillable: () => 'Explorable',
  vis_invalidData: () => 'Données non valides',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' sur ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Sélection par rectangle de sélection',
  vis_marqueeZoomTooltip: () => 'Zoom par rectangle de sélection',
  vis_noData: () => 'Aucune donnée à afficher',
  vis_panTooltip: () => 'Panoramique',
  vis_stateCollapsed: () => 'Réduit',
  vis_stateExpanded: () => 'Développé',
  vis_stateLoaded: () => 'Chargé',
  vis_stateLoading: () => 'Chargement en cours',
  vis_stateSelected: () => 'Sélectionné',
  vis_stateUnselected: () => 'Désélectionné',
  warn: () => 'Avertissement'
};
export default bundle;
